module.exports = __webpack_public_path__ + "static/media/1717128339188-min.589da748.JPG";